import { GeckoEntryBase, RolodexEntryType } from 'types'

import { GeckoInspectionType } from './geckoInspection'

export enum InspectionAssessmentSurfaceCondition {
  GOOD = 'good',
  ACCEPTABLE = 'acceptable',
  POOR = 'poor',
}
export type InspectionAssessmentData = {
  inspectionType: GeckoInspectionType
  inspectionScope?: string
  surfaceCondition?: InspectionAssessmentSurfaceCondition | string
  estimateCoverage?: number
  conditionNotes?: string
  coverageNotes?: string
  hasCoating?: boolean
  surfaceTemperature?: number
  physicalAccessRequirements?: string[]
  waterAccess?: boolean
  powerAccess?: boolean
  accessNotes?: string
  assessment_type?: unknown
  overall_condition?: unknown
  recommended_action?: unknown
  notes?: unknown
}

export type InspectionAssessment = GeckoEntryBase<
  InspectionAssessmentData,
  {
    organization: string
    site: string
    [RolodexEntryType.UNIT]: string
    [RolodexEntryType.COMPONENT]?: string
  }
>
